import axios from 'axios';

/**
 * Liste des actions
 */
export const Actions = {
    FETCH_PIECE_GESTION_LIGNES_REQUEST: 'FETCH_PIECE_GESTION_LIGNES_REQUEST',
    FETCH_PIECE_GESTION_LIGNES_SUCCESS: 'FETCH_PIECE_GESTION_LIGNES_SUCCESS',
    FETCH_PIECE_GESTION_LIGNES_FAILURE: 'FETCH_PIECE_GESTION_LIGNES_FAILURE',

    CLEAR_PIECE_GESTION_LIGNES: 'CLEAR_PIECE_GESTION_LIGNES'
};

/**
 * ActionCreator pour FETCH_PIECE_GESTION_LIGNES_REQUEST
 */
const fetchPieceGestionLignesRequest = () => ({ type: Actions.FETCH_PIECE_GESTION_LIGNES_REQUEST });

/**
 * ActionCreator pour FETCH_PIECE_GESTION_LIGNES_SUCCESS
 */
const fetchPieceGestionLignesSuccess = pieceGestionLignes => ({ type: Actions.FETCH_PIECE_GESTION_LIGNES_SUCCESS, pieceGestionLignes });

/**
 * ActionCreator pour FETCH_PIECE_GESTION_LIGNES_FAILURE
 */
const fetchPieceGestionLignesFailure = error => ({ type: Actions.FETCH_PIECE_GESTION_LIGNES_FAILURE, error });

/**
 * ActionCreator pour la récupération des lignes d'un pièce gestion
 */
export const fetchPieceGestionLignes = (numeroPiece, defautProduitInfos = false, logistiqueInfos = false, savInfos = false, codeDepot = null) => async (dispatch) => {
    dispatch(fetchPieceGestionLignesRequest());

    try {
        let response = await axios.get('api/piece-gestion-lignes', {
            params: {
                numeroPiece: numeroPiece,
                defautProduitInfos: defautProduitInfos,
                logistiqueInfos: logistiqueInfos,
                savInfos: savInfos,
                codeDepot: codeDepot
            }
        });

        dispatch(fetchPieceGestionLignesSuccess(response.data));

    } catch (error) {
        dispatch(fetchPieceGestionLignesFailure(error));
    }
};

/**
 * Mappe une ligne de commande (CommandeGestionLignesQueryResult.LigneQueryResult)
 * vers le format des lignes de pièce attendu par le store / les composants partagés
 * (LigneGestionQualification, LigneEditee...).
 *
 * En mode commande, la colonne « quantité commandée » affichée reste quantite (= quantité
 * commandée), mais le cap de saisie et la garde s'appuient sur quantiteRetournable, exposée
 * en plus (avec quantiteLivree / quantiteEnCoursDossier) pour les colonnes spécifiques commande.
 */
const mapLigneCommandeVersPiece = (ligne) => ({
    numeroLigne: ligne.numeroLigne,
    codeArticle: ligne.codeArticle,
    designationArticle: ligne.designationArticle,
    // « Quantité commandée » affichée dans la colonne quantité de la vue partagée.
    quantite: ligne.quantiteCommandee,
    prixUnitaire: ligne.prixUnitaire,
    valeurUnitaire: ligne.prixUnitaire,

    ordreKit: ligne.ordreKit,
    kitType: ligne.kitType,
    erreurKit: ligne.erreurKit,

    retourExclusionFlag: ligne.retourExclusionFlag,
    perissable: ligne.perissable,

    poids: ligne.poids,
    marqueExclusive: false,
    // Fournisseur : objet { code, nom } renvoyé tel quel par le back (forme uniformisée BL/commande).
    fournisseur: ligne.fournisseur || null,

    // --- Champs spécifiques au mode commande (colonnes additionnelles + cap de saisie) ---
    quantiteCommandee: ligne.quantiteCommandee,
    quantiteLivree: ligne.quantiteLivree,
    quantiteEnCoursDossier: ligne.quantiteEnCoursDossier,
    quantiteRetournable: ligne.quantiteRetournable,
    piecesLivraison: ligne.piecesLivraison
});

/**
 * ActionCreator pour la récupération des lignes d'une COMMANDE (RV depuis commande, DEV-4012).
 * Alimente le même store que fetchPieceGestionLignes (format mappé), pour que les composants
 * partagés fonctionnent à l'identique.
 */
export const fetchCommandeGestionLignes = (cle, codeDepot = null) => async (dispatch) => {
    dispatch(fetchPieceGestionLignesRequest());

    try {
        let response = await axios.get('api/commande-gestion-lignes', {
            params: {
                cle: cle,
                codeDepot: codeDepot
            }
        });

        // Le controller renvoie directement le tableau de lignes (Ok(result.Lignes)).
        const lignes = (response.data || []).map(mapLigneCommandeVersPiece);

        dispatch(fetchPieceGestionLignesSuccess(lignes));

    } catch (error) {
        dispatch(fetchPieceGestionLignesFailure(error));
    }
};

/**
 * ActionCreator pour CLEAR_PIECE_GESTION_LIGNES
 */
export const clearPieceGestionLignes = () => ({ type: Actions.CLEAR_PIECE_GESTION_LIGNES });